import { Directive, inject, Input, OnInit } from '@angular/core';
import { Store } from '@sama/app-state';
import { isEqual } from 'lodash';
import { DebouncedEventTracker } from '../../../../cross-team-shared/event-tracking/debounced-event-tracker';
import { EventTrackingService } from '../../../../shared/event-tracking/event-tracking.service';
import { defaultSettingConfig } from './settings-panel/slider-settings-config';

@Directive()
export class AbstractViewSettingsSliderComponent<T> implements OnInit {
  @Input({ required: true }) defaultValue!: T;
  @Input({ required: true }) label!: string;
  @Input() config = defaultSettingConfig;
  @Input() suffix = '%';
  @Input({ required: true }) settingName!: string;
  @Input({ required: true }) settingStore!: Store<T>;

  protected eventTracker = new DebouncedEventTracker(
    {
      id: 'adjust_view_setting',
      bucket: 'navigation',
      sub_bucket: 'frame',
    },
    inject(EventTrackingService),
  );

  formatValue = (value: number) => `${value}${this.suffix}`;

  ngOnInit() {
    this.eventTracker.addContext({
      method: this.settingName,
      batch_included_reset: false,
    });
  }

  reset(source = 'mouse') {
    if (isEqual(this.settingStore.state(), this.defaultValue)) {
      return;
    }
    this.eventTracker.addBatchContext({ batch_included_reset: true });

    this.settingStore.set(this.defaultValue);

    this.eventTracker.trackWithDebounce({
      source,
      value: this.defaultValue,
    });
  }

  protected setValueAndTrackEvent(value: number, settingStore: Store<number>) {
    settingStore.set(value);
    this.eventTracker.trackWithDebounce({
      source: 'mouse',
      value,
    });
  }
}
